import { generateUniqueID } from "../utils/generateUniqueID";
import img3 from "../assets/_home/newestCollection3.png";
import img4 from "../assets/_home/newestCollection4.png";

export const newest = [
  {
    id: generateUniqueID(),
    media: img3,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "image",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img4,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "video",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img3,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "gif",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img4,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "image",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img3,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "image",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img4,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "video",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img3,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "gif",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img4,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "image",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img3,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "image",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img4,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "video",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img3,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "gif",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img3,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "image",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img4,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "video",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img3,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "gif",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img3,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "image",
    price: 0.56,
    likes: 12,
  },
  {
    id: generateUniqueID(),
    media: img4,
    name: "Cryptographics #1267",
    creator: "Cryptographics",
    type: "video",
    price: 0.56,
    likes: 12,
  },
];
